export default {
    tabs: []
};
